// extracted by mini-css-extract-plugin
module.exports = {"root":"product-error-page_root___uNdM"};